import { RequestBazowy } from './requestBazowy';
import { Sortowanie } from './sortowanie';
import { Stronicowanie } from './stronicowanie';

export class RejestrFiltrowanyRequest<T> extends RequestBazowy {
    stronicowanie: Stronicowanie;
    sortowanie: Sortowanie;
    filtry: T;
}